import { useCallback, useEffect, useState } from "react";

export function useFullscreen() {
    const [isFullscreen, setIsFullscreen] = useState(!!document.fullscreenElement);

    useEffect(() => {
        const handler = () => setIsFullscreen(!!document.fullscreenElement);
        document.addEventListener("fullscreenchange", handler);
        return () => document.removeEventListener("fullscreenchange", handler);
    }, []);

    const request = useCallback((): Promise<void> => {
        const el = document.documentElement;

        if (typeof el.requestFullscreen === "function") {
            return el.requestFullscreen().then(() => {}, () => {});
        }

        const legacy = el as Element & {
            webkitRequestFullscreen?: () => void;
            mozRequestFullScreen?: () => void;
            msRequestFullscreen?: () => void;
        };

        const method = legacy.webkitRequestFullscreen ?? legacy.mozRequestFullScreen ?? legacy.msRequestFullscreen;
        method?.call(el);

        return Promise.resolve();
    }, []);

    const exit = useCallback((): Promise<void> => {
        return document.exitFullscreen().catch(() => {});
    }, []);

    return { isFullscreen, request, exit };
}